import styled from '@emotion/styled';
import { SkeletonBar, SkeletonRect } from 'src/components/Skeleton';
const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;
const BottomGradient = styled.div`
  position: absolute;
  bottom: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  height: 400px;
  pointer-events: none;
  background: linear-gradient(180deg, transparent 0%, ${({
  theme
}) => theme.color.bg2} 100%);

  ${({
  theme
}) => theme.screenSize.mobile} {
    background: linear-gradient(180deg, transparent 0%, ${({
  theme
}) => theme.color.bg1} 100%);
  }
`;
const BannerSection = styled.div`
  padding: 8px 16px;
`;
const BannerSkeleton = styled(SkeletonRect)`
  height: 100px;
  border-radius: 16px;
`;
const SectionTitleArea = styled.div`
  padding: 12px 16px;
`;
const ProductListSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 16px 16px;
`;
const ProductCardSkeleton = styled(SkeletonRect)`
  height: 100px;
  border-radius: 16px;
  flex-shrink: 0;
`;
const PRODUCT_SKELETON_COUNT = 8;
const ShopLoading = () => <Container data-testid='Shop-Loading' data-sentry-element="Container" data-sentry-component="ShopLoading" data-sentry-source-file="Loading.tsx">
    <BannerSection data-sentry-element="BannerSection" data-sentry-source-file="Loading.tsx">
      <BannerSkeleton data-sentry-element="BannerSkeleton" data-sentry-source-file="Loading.tsx" />
    </BannerSection>
    <SectionTitleArea data-sentry-element="SectionTitleArea" data-sentry-source-file="Loading.tsx">
      <SkeletonBar width='160px' height={24} data-sentry-element="SkeletonBar" data-sentry-source-file="Loading.tsx" />
    </SectionTitleArea>
    <ProductListSection data-sentry-element="ProductListSection" data-sentry-source-file="Loading.tsx">
      {Array.from({
      length: PRODUCT_SKELETON_COUNT
    }).map((_, index) => <ProductCardSkeleton key={index} />)}
    </ProductListSection>
    <BottomGradient data-sentry-element="BottomGradient" data-sentry-source-file="Loading.tsx" />
  </Container>;
export default ShopLoading;